import React, { useState, useEffect } from 'react';
import { seasonsAPI } from '../../services/api';

const SeasonsSettings = () => {
  const [seasons, setSeasons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingSeason, setEditingSeason] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    state: true
  });

  useEffect(() => {
    fetchSeasons();
  }, []);

  const fetchSeasons = async () => {
    try {
      const response = await seasonsAPI.getAll();
      setSeasons(response.data);
    } catch (err) {
      setError('Failed to fetch seasons');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingSeason) {
        await seasonsAPI.update(editingSeason._id, formData);
      } else {
        await seasonsAPI.create(formData);
      }
      fetchSeasons();
      resetForm();
    } catch (err) {
      setError('Failed to save season');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this season?')) {
      try {
        await seasonsAPI.delete(id);
        fetchSeasons();
      } catch (err) {
        setError('Failed to delete season');
      }
    }
  };

  const resetForm = () => {
    setFormData({ name: '', state: true });
    setEditingSeason(null);
    setShowModal(false);
  };

  const handleEdit = (season) => {
    setFormData({
      name: season.name,
      state: season.state
    });
    setEditingSeason(season);
    setShowModal(true);
  };

  if (loading) return <div className="loading loading-spinner loading-lg"></div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Seasons</h2>
        <button 
          className="btn btn-primary"
          onClick={() => setShowModal(true)}
        >
          Add Season
        </button>
      </div>

      {error && (
        <div className="alert alert-error">
          <span>{error}</span>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th>Name</th>
              <th>State</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(seasons) && seasons.map((season) => (
              <tr key={season._id}>
                <td>{season.name}</td>
                <td>
                  <div className={`badge ${season.state ? 'badge-success' : 'badge-error'}`}>
                    {season.state ? 'Active' : 'Inactive'}
                  </div>
                </td>
                <td>{new Date(season.createdAt).toLocaleDateString()}</td>
                <td>
                  <div className="space-x-2">
                    <button 
                      className="btn btn-sm btn-outline"
                      onClick={() => handleEdit(season)}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn btn-sm btn-error"
                      onClick={() => handleDelete(season._id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <dialog open className="modal">
          <div className="modal-box">
            <h3 className="font-bold text-lg">
              {editingSeason ? 'Edit Season' : 'Add New Season'}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Name</span>
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="input input-bordered"
                  required
                />
              </div>
              <div className="form-control">
                <label className="label cursor-pointer">
                  <span className="label-text">Active</span>
                  <input
                    type="checkbox"
                    checked={formData.state}
                    onChange={(e) => setFormData({...formData, state: e.target.checked})}
                    className="checkbox"
                  />
                </label>
              </div>
              <div className="modal-action">
                <button type="submit" className="btn btn-primary">
                  {editingSeason ? 'Update' : 'Create'}
                </button>
                <button type="button" className="btn" onClick={resetForm}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </dialog>
      )}
    </div>
  );
};

export default SeasonsSettings;
